/**
 * millis — една дата, стигнала до нас в който и да е от четирите си вида.
 *
 * Причината да е отделно: същата стойност идва като Firestore `Timestamp` в
 * Cloud Function, като `{_seconds, _nanoseconds}` след JSON сериализация през
 * callable, като `Date` от формуляр и като ISO низ от импорт. Всяко място, което
 * си пише собствено превръщане, го пише малко по-различно — и разликите се
 * виждат чак когато две подредби се разминат.
 *
 * Връща `null`, а не `0`, при непознат вход: `0` е валиден момент (1970) и
 * сравнение срещу него мълчи, вместо да покаже липсата.
 */
export function toMillisOrNull(value: unknown): number | null {
  if (value == null) return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  if (value instanceof Date) {
    const t = value.getTime();
    return Number.isNaN(t) ? null : t;
  }
  if (typeof value === 'string') {
    const t = Date.parse(value);
    return Number.isNaN(t) ? null : t;
  }
  if (typeof value !== 'object') return null;

  const obj = value as {
    toMillis?: () => number;
    seconds?: number;
    _seconds?: number;
  };
  if (typeof obj.toMillis === 'function') {
    const t = obj.toMillis();
    return Number.isFinite(t) ? t : null;
  }
  const secs = typeof obj.seconds === 'number' ? obj.seconds : obj._seconds;
  if (typeof secs === 'number' && Number.isFinite(secs)) return secs * 1000;
  return null;
}
